import React, { useContext } from "react";
import { Input } from "antd";
import GainIcon from "../gainicon";

import { CardContext } from "./CardTitle";

export default function SearchInput() {
  const { onSearch } = useContext(CardContext);
  return (
    <Input
      className="rounded-xl bg-gray-100 border-none ml-1"
      size="large"
      placeholder="Search..."
      prefix={<GainIcon name="search" />}
      onChange={(e) => onSearch(e.target.value)}
      allowClear
    />
  );
}
